import Head from "next/head";

const BoardsFAQSchema = ({ tenthResult = true, schemaValues = null }) => {
  return (
    <Head>
      {!schemaValues ? (
        <script
          id="FAQPageSchema"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: !tenthResult
                ? [
                    {
                      "@type": "Question",
                      name: "कब आएगा बिहार बोर्ड 12वीं की परीक्षा का रिजल्ट?",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: "परीक्षा खत्म होते ही बोर्ड के परीक्षार्थियों में रिजल्ट को लेकर बेचैनी बढ़ गई है. बिहार बोर्ड 12वीं की परीक्षा इस बार 1 फरवरी से 15 फरवरी के बीच आयोजित हुई थी. कॉपियों का मूल्यांकन पूरा हो चुका है. बताया जा रहा है कि टॉपर्स के नाम भी करीब-करीब फाइनल हो चुके हैं. नतीजे 24 मार्च के आसपास जारी हो सकते हैं.",
                      },
                    },
                    {
                      "@type": "Question",
                      name: "newstak.in पर बिहार बोर्ड 12वीं का रिजल्ट कैसे चेक करें?",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: `स्टेप 1: न्यूज Tak की वेबसाइट newstak.in पर जाएं.
स्टेप 2: होमपेज पर 'बोर्ड रिजल्ट' लिंक पर क्लिक करें.
स्टेप 3: यहां बिहार बोर्ड 12वीं रिजल्ट' लिंक पर क्लिक करें.
स्टेप 4: यहां अपना रोल नंबर डालें.
स्टेप 5: बिहार 12वीं बोर्ड रिजल्ट की मार्कशीट स्क्रीन पर ओपन हो जाएगी.
स्टेप 6: मार्कशीट डाउनलोड कर सकते हैं.`,
                      },
                    },
                    {
                      "@type": "Question",
                      name: "12वीं बोर्ड का रिजल्ट जानने का तरीका क्या है?",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: `स्टेप 1: बिहार बोर्ड की आधिकारिक वेबसाइट http://seniorsecondary.biharboardonline.com/ पर जाएं.
स्टेप 2: होमपेज पर, 'BSEB Result' पर क्लिक करें.
स्टेप 3: अब अपना रोल नंबर और कैप्चा कोड डालकर सबमिट करें.
स्टेप 4: रिजल्ट आपकी स्क्रीन पर ओपन हो जाएगा.
स्टेप 5: स्टूडेंट अपनी ऑनलाइन मार्कशीट डाउनलोड कर सकते हैं.`,
                      },
                    },
                    {
                      "@type": "Question",
                      name: "बोर्ड परीक्षा में कौन पास, कौन फेल?",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: "बोर्ड परीक्षा पास करने के लिए प्रत्येक विषय में कम से कम 33 फीसदी अंक पाना जरूरी है.",
                      },
                    },
                  ]
                : [
                    {
                      "@type": "Question",
                      name: "कब आएगा बिहार बोर्ड 10वीं की परीक्षा का रिजल्ट?",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: "परीक्षा खत्म होते ही बोर्ड के परीक्षार्थियों को रिजल्ट का बेशब्री से इंतजार रहता है. बिहार बोर्ड 10वीं की परीक्षा इस बार 17 फरवरी से 25 फरवरी के बीच आयोजित हुई थी. 10वीं की कॉपियों के मूल्यांकन की प्रक्रिया 1 मार्च से शुरू होकर 10 मार्च को पूरी हो गई थीं. बोर्ड अब टॉपर्स के नाम फाइनल करेगा. रिजल्ट बनेगा और फिर परिणाम घोषित होंगे. माना जा रहा है कि रिजल्ट अप्रैल के पहले सप्ताह में जारी हो सकते हैं.",
                      },
                    },
                    {
                      "@type": "Question",
                      name: "newstak.in पर बिहार बोर्ड 10वीं का रिजल्ट कैसे चेक करें?",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: `स्टेप 1: न्यूज Tak की वेबसाइट newstak.in पर जाएं.
स्टेप 2: होमपेज पर 'बोर्ड रिजल्ट' लिंक पर क्लिक करें.
स्टेप 3: यहां बिहार बोर्ड 10वीं रिजल्ट' लिंक पर क्लिक करें.
स्टेप 4: यहां अपना रोल नंबर डालें.
स्टेप 5: बिहार 10वीं बोर्ड रिजल्ट की मार्कशीट स्क्रीन पर ओपन हो जाएगी.
स्टेप 6: मार्कशीट डाउनलोड कर सकते हैं.`,
                      },
                    },
                    {
                      "@type": "Question",
                      name: "10वीं बोर्ड का रिजल्ट जानने का तरीका क्या है?",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: `स्टेप 1: बिहार बोर्ड की आधिकारिक वेबसाइट http://seniorsecondary.biharboardonline.com/ पर जाएं.
स्टेप 2: होमपेज पर, 'BSEB Result' पर क्लिक करें.
स्टेप 3: अब अपना रोल नंबर और कैप्चा कोड डालकर सबमिट करें.
स्टेप 4: रिजल्ट आपकी स्क्रीन पर ओपन हो जाएगा.
स्टेप 5: स्टूडेंट अपनी ऑनलाइन मार्कशीट डाउनलोड कर सकते हैं.`,
                      },
                    },
                    {
                      "@type": "Question",
                      name: "बोर्ड परीक्षा में कौन पास, कौन फेल?",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: "बोर्ड परीक्षा पास करने के लिए प्रत्येक विषय में कम से कम 33 फीसदी अंक पाना जरूरी है.",
                      },
                    },
                  ],
            }),
          }}
        />
      ) : (
        <script
          id="FAQPageSchema"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: schemaValues,
            }),
          }}
        />
      )}
    </Head>
  );
};

export default BoardsFAQSchema;
